import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import {
  DynamicReportProxy,
  FinancialAnalysisProxy,
  LibraryProxy,
} from './proxy'

class DetailTemplateService extends ServiceBase {
  searchCompany(params) {
    return this.getData(() => DynamicReportProxy.searchCompany(params))
  }

  getTemplate(params) {
    return this.getData(() => DynamicReportProxy.getTemplate(params))
  }

  getIndicators(params) {
    return this.applyMemoryCache(
      'dynamicReport/getIndicators',
      params,
    )(() => FinancialAnalysisProxy.getIndicators(params))
  }

  getAllPortfolio(params) {
    return this.getData(() => LibraryProxy.getSearchPortfolio(params))
  }
}

export default new DetailTemplateService()
